<template>
  <Layout :footer-style="2">
    <!-- Start Slider Area -->
    <div class="slider-area slider-style-4 slider-dot rn-slick-dot rn-slick-arrow">
      <VueSlickCarousel v-bind="sliderSetting">
        <div v-for="(slider, index) in sliderData" :key="index" class="single-slide">
          <div class="height-950 bg-overlay bg_image"
               :style="{'background-image': `url(${require(`@/assets/images/bg/${slider.image}.jpg`)})`}">
            <div class="container">
              <div class="row row--30 align-items-center">
                <div class="order-2 order-lg-1 col-lg-7">
                  <div class="inner text-start">
                    <h1 class="title" v-html="slider.title"/>
                    <p class="description" v-html="slider.description"/>
                    <!--                                        <div class="button-group mt&#45;&#45;30">
                                                                <a class="btn-default"
                                                                   href="#">
                                                                    PURCHASE NOW
                                                                </a>
                                                            </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
    <!-- End Slider Area -->


  </Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import Separator from '../../components/elements/separator/Separator'
import VueSlickCarousel from 'vue-slick-carousel'
import BlogPost from '../../components/blog/BlogPost'
import BlogPostMixin from '../../mixins/BlogPostMixin'
import Testimonial from '../../components/elements/testimonial/Testimonial'
import Portfolio from '../../components/elements/portfolio/Portfolio'
import ServiceFive from '../../components/elements/service/ServiceFive'
import Progressbar from '../../components/elements/progressbar/Progressbar'

export default {
  name: 'DigitalAgency',
  components: {
    Progressbar,
    ServiceFive,
    Portfolio,
    Testimonial,
    BlogPost,
    Separator,
    SectionTitle,
    Layout,
    VueSlickCarousel
  },
  mixins: [BlogPostMixin],
  data() {
    return {
      sliderSetting: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 993,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      },
      sliderData: [
        {
          image: 'bg-image-6',
          title: '',
          description: ''
        },
        {
          image: 'bg-image-14',
          title: '',
          description: ''
        },
        {
          image: 'bg-image-15',
          title: '',
          description: ''
        },

        {
          image: 'bg-image-15',
          title: 'Startup Agency.',
          description: ''
        },
      ],

    }
  }
}
</script>